import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  --bgColor: ${brand.white};

  position: fixed;
  top: var(--headerHeight);
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  height: max-content;
  max-height: calc(100vh - var(--headerHeight)); // to make it scrollable
  opacity: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  pointer-events: none;
  transition: opacity 0.3s ${cubicEaseOut};
  width: 320px;
  
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
  margin: 0 0 0 1px;

  [data-d-active='true'] & {
    opacity: 1;
    pointer-events: all;
  }
`;
const List = styled.ul `
  overflow-y: auto;
   overflow-x: hidden;
`;
const Item = styled.li `
  display: flex;
  width: 320px;
  position: relative;
`;
const ChevronLink = styled.a `
  padding: 16px;
  flex: 0 0 56px;
  position: absolute;
  right:0;
  height: 60px;

  &:focus,
  &:hover {
    outline: none;
    cursor: pointer;
    background: ${brand.grey.grey1};
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: ${brand.new.darkgrey};
  ${fonts.body.regular};
  font-size: 18px;
  line-height: 28px;
  padding: 16px 0 16px 24px;
  text-decoration: none;
  border: none;
  outline: none;
  border-bottom: 1px solid ${brand.new.midblue};
  transition: all 0.1s ${cubicEaseOut};
  width: 100%;
 
  li:has(> ${ChevronLink}:hover) &,
  &:focus,
  &:hover {
    outline: none; 
    background: ${brand.grey.grey1};
    color: ${brand.black};
  }

  li:has(> [data-active='true']) & {
    border-left: 10px solid ${brand.yellow.base};
    background: ${brand.grey.grey1};
  }
`;
const Text = styled.span `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 0 auto;
  
  li:has(> ${ChevronLink}) & {
    flex: 0 0 calc(100% - 66px);
    max-width: calc(100% - 66px); 
  }
`;
const SubList = styled.ul `
  overflow: hidden;
  transition: all 0.3s ${cubicEaseOut};
  max-height: 0;
  
  &[data-active='true'] {
    max-height: 600px; 
  }

  ${Link}:not([data-active='true']) {
    background-color: ${brand.new.cream};
    border-left: 10px solid ${brand.blue.blue5};
    &:focus,
    &:hover {
      outline: none; 
      background: ${brand.grey.grey1};
      color: ${brand.black};
    }
  }

  li:has(> [data-active='true']) ${Link} {
    background: ${brand.grey.grey1};
  }
}
`;
const DesktopDropdownStyles = {
    Container,
    List,
    SubList,
    Item,
    Link,
    ChevronLink,
    Text,
};
export default DesktopDropdownStyles;
